export default __webpack_public_path__ + "static/project-slide-3-2016-765-6fd72c471fcc30e677294c6855f97e93.jpg";